import SignContractsTab from "pages/SignContracts/components/SignContractsTab";
import * as yup from "yup";
import {stringRequired} from "yup/defaultValudations";

export const signContractsTabKeys = {
  SIGN_CONTRACTS_BUYER_TAB: "SIGN_CONTRACTS_BUYER_TAB",
  SIGN_CONTRACTS_SELLER_TAB: "SIGN_CONTRACTS_SELLER_TAB",
};

export const signContractsTabs = [
  {
    title: signContractsTabKeys.SIGN_CONTRACTS_BUYER_TAB,
    content: SignContractsTab,
    id: 0,
    hash: "#",
    visible: true,
    requestKey: "created",
  },
  {
    title: signContractsTabKeys.SIGN_CONTRACTS_SELLER_TAB,
    content: SignContractsTab,
    id: 1,
    hash: "#",
    visible: true,
    requestKey: "sent",
  },
];

export const signContractSide = {
  BUYER: "BUYER",
  SELLER: "SELLER",
};

export const signContractPartySide = {
  OWN: "OWN",
  THEIR: "THEIR",
};

export const signContractPartyMemberSide = {
  OWN: "initiatingMembers",
  THEIR: "counterpartyMembers",
};

export const sortSignContractsSelectItems = [
  {label: "SIGN_CONTRACT_SORT_SELECT_DATE", value: "createdAt"},
  {label: "SIGN_CONTRACT_SORT_SELECT_MY", value: "my"},
  {label: "SIGN_CONTRACT_SORT_SELECT_ALPHABETICALLY", value: "abc"},
];

export const signContractStatus = {
  DRAFT: "DRAFT",
  SIGNING: "SIGNING",
  SIGNED: "SIGNED",
};

export const signContractStatusKey = {
  SIGN_CONTRACT_STATUS_DRAFT: signContractStatus.DRAFT,
  SIGN_CONTRACT_STATUS_SIGNING: signContractStatus.SIGNING,
  SIGN_CONTRACT_STATUS_SIGNED: signContractStatus.SIGNED,
};

export const signContractStatusName = {
  [signContractStatus.DRAFT]: "SIGN_CONTRACT_STATUS_DRAFT",
  [signContractStatus.SIGNING]: "SIGN_CONTRACT_STATUS_SIGNING",
  [signContractStatus.SIGNED]: "SIGN_CONTRACT_STATUS_SIGNED",
};

export const signContractStatuses = Object.values(signContractStatus);

export const signContractStatuseNames = [
  "SIGN_CONTRACT_STATUS_SELECT_STATUS",
  signContractStatusName.DRAFT,
  signContractStatusName.SIGNING,
  signContractStatusName.SIGNED,
];

export const signContractStatusColor = {
  [signContractStatus.DRAFT]: "red",
  [signContractStatus.SIGNING]: "orange",
  [signContractStatus.SIGNED]: "green",
};

export const signContractMemberStatus = {
  QUEUED: "QUEUED",
  READ: "READ",
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  REMINDED: "REMINDED",
  BOUNCED: "BOUNCED",
  SIGNED: "SIGNED",
};

export const signContractMemberStatusName = {
  [signContractMemberStatus.QUEUED]: "SIGN_CONTRACT_MEMBER_STATUS_QUEUED",
  [signContractMemberStatus.SENT]: "SIGN_CONTRACT_MEMBER_STATUS_SENT",
  [signContractMemberStatus.DELIVERED]: "SIGN_CONTRACT_MEMBER_STATUS_DELIVERED",
  [signContractMemberStatus.BOUNCED]: "SIGN_CONTRACT_MEMBER_STATUS_BOUNCED",
  [signContractMemberStatus.READ]: "SIGN_CONTRACT_MEMBER_STATUS_READ",
  [signContractMemberStatus.REMINDED]: "SIGN_CONTRACT_MEMBER_STATUS_REMINDED",
  [signContractMemberStatus.SIGNED]: "SIGN_CONTRACT_MEMBER_STATUS_SIGNED",
};

export const signContractMemberStatusNameToStatus = {
  [signContractMemberStatusName[signContractMemberStatus.QUEUED]]:
    signContractMemberStatus.QUEUED,
  [signContractMemberStatusName[signContractMemberStatus.SENT]]:
    signContractMemberStatus.SENT,
  [signContractMemberStatusName[signContractMemberStatus.DELIVERED]]:
    signContractMemberStatus.DELIVERED,
  [signContractMemberStatusName[signContractMemberStatus.BOUNCED]]:
    signContractMemberStatus.BOUNCED,
  [signContractMemberStatusName[signContractMemberStatus.READ]]:
    signContractMemberStatus.READ,
  [signContractMemberStatusName[signContractMemberStatus.REMINDED]]:
    signContractMemberStatus.REMINDED,
  [signContractMemberStatusName[signContractMemberStatus.SIGNED]]:
    signContractMemberStatus.SIGNED,
};

export const signContractMemberStatusColor = {
  [signContractMemberStatus.QUEUED]: "discreteText",
  [signContractMemberStatus.SENT]: "discreteText",
  [signContractMemberStatus.DELIVERED]: "black",
  [signContractMemberStatus.BOUNCED]: "red",
  [signContractMemberStatus.READ]: "orange",
  [signContractMemberStatus.REMINDED]: "discreteText",
  [signContractMemberStatus.SIGNED]: "green",
};

export const defaultSignContractsParamsSearch = {
  sort: sortSignContractsSelectItems[0].value,
  tab: "created",
  page: 1,
};

export const signContractIdentifyMethod = {
  BANKID: "BANKID",
  SMS: "SMS",
  BASIC_AUTH: "BASIC_AUTH",
};

export const signContractAuthenticateStatus = Object.freeze({
  SMS_AUTHENTICATED: "SMS_AUTHENTICATED",
  BANKID_AUTHENTICATED: "BANKID_AUTHENTICATED",
  BASIC_AUTH: "BASIC_AUTH",
});

export const signContractSmsVerifyApiError = {
  SESSION_EXPIRED: "HS_SMS_VERIFY_EXPIRED",
};

export const signContractIdentifyMethodOptions = [
  {
    value: signContractIdentifyMethod.BANKID,
    label: "SIGN_CONTRACT_IDENTIFY_METHOD_BANKID",
  },
  {value: signContractIdentifyMethod.SMS, label: "SIGN_CONTRACT_IDENTIFY_METHOD_SMS"},
  {
    value: signContractIdentifyMethod.BASIC_AUTH,
    label: "SIGN_CONTRACT_IDENTIFY_METHOD_BASIC",
  },
];

export const signContractPdfStatus = {
  INITIAL: "INITIAL",
  STAMPING: "STAMPING",
  PREPARING: "PREPARING",
  READY: "READY",
};

export const downloadPdfButtonName = {
  [signContractPdfStatus.INITIAL]: "SIGN_CONTRACT_ACTION_BUTTON_DOWNLOAD_PDF",
  [signContractPdfStatus.STAMPING]: "SIGN_CONTRACT_ACTION_BUTTON_DOWNLOAD_PDF_STAMPING",
  [signContractPdfStatus.PREPARING]: "SIGN_CONTRACT_ACTION_BUTTON_DOWNLOAD_PDF_PREPARING",
  [signContractPdfStatus.READY]: "SIGN_CONTRACT_ACTION_BUTTON_DOWNLOAD_PDF_READY",
};

export const signContractMemberSchema = yup.object().shape({
  firstName: stringRequired().nullable(),
  lastName: stringRequired().nullable(),
  companyNumber: yup.string().nullable(),
  companyName: yup.string().nullable(),
});

export const initialManuallyMember = {
  firstName: null,
  lastName: null,
  companyName: null,
  companyNumber: null,
};

export const listLanguageKey = "SIGN_CONTRACT_INVOICING_PROFILES_MODAL_LIST_";
export const itemLanguageKey = "SIGN_CONTRACT_INVOICING_PROFILES_MODAL_ITEM_";

export const invoiceProfileFieldProps = {
  companyName: {
    name: "companyName",
    label: `${itemLanguageKey}COMPANY_NAME`,
    placeholder: `${itemLanguageKey}COMPANY_NAME_PLACEHOLDER`,
  },
  companyNumber: {
    name: "companyNumber",
    label: `${itemLanguageKey}COMPANY_NUMBER`,
    placeholder: `${itemLanguageKey}COMPANY_NUMBER_PLACEHOLDER`,
  },
  companyAddressMain: {
    name: "companyAddressMain",
    label: `${itemLanguageKey}COMPANY_ADDRESS_MAIN`,
    placeholder: `${itemLanguageKey}COMPANY_ADDRESS_MAIN_PLACEHOLDER`,
  },
  companyAddressExtra: {
    name: "companyAddressExtra",
    placeholder: `${itemLanguageKey}COMPANY_ADDRESS_EXTRA_PLACEHOLDER`,
  },
  companyAddressPostalCode: {
    name: "companyAddressPostalCode",
    placeholder: `${itemLanguageKey}COMPANY_ADDRESS_POSTAL_CODE_PLACEHOLDER`,
  },
  companyAddressCity: {
    name: "companyAddressCity",
    placeholder: `${itemLanguageKey}COMPANY_ADDRESS_CITY_PLACEHOLDER`,
  },
  intDesignation: {
    name: "intDesignation",
    label: `${itemLanguageKey}INT_DESIGNATION`,
    placeholder: `${itemLanguageKey}INT_DESIGNATION_PLACEHOLDER`,
  },
  email: {
    name: "email",
    label: `${itemLanguageKey}EMAIL`,
    placeholder: `${itemLanguageKey}EMAIL_PLACEHOLDER`,
  },
  addressMain: {
    name: "addressMain",
    label: `${itemLanguageKey}ADDRESS_MAIN`,
    placeholder: `${itemLanguageKey}ADDRESS_MAIN_PLACEHOLDER`,
  },
  addressExtra: {
    name: "addressExtra",
    placeholder: `${itemLanguageKey}ADDRESS_EXTRA_PLACEHOLDER`,
  },
  addressPostalCode: {
    name: "addressPostalCode",
    placeholder: `${itemLanguageKey}ADDRESS_POSTAL_CODE_PLACEHOLDER`,
  },
  addressCity: {
    name: "addressCity",
    placeholder: `${itemLanguageKey}ADDRESS_CITY_PLACEHOLDER`,
  },
  glnNumber: {
    name: "glnNumber",
    label: `${itemLanguageKey}GLN_NUMBER`,
    placeholder: `${itemLanguageKey}GLN_NUMBER_PLACEHOLDER`,
  },
  peppolId: {
    name: "peppolId",
    label: `${itemLanguageKey}PEPPOL_ID`,
    placeholder: `${itemLanguageKey}PEPPOL_ID_PLACEHOLDER`,
  },
  inxNumber: {
    name: "inxNumber",
    label: `${itemLanguageKey}INX_NUMBER`,
    placeholder: `${itemLanguageKey}INX_NUMBER_PLACEHOLDER`,
  },
  vatNumber: {
    name: "vatNumber",
    label: `${itemLanguageKey}VAT_NUMBER`,
    placeholder: `${itemLanguageKey}VAT_NUMBER_PLACEHOLDER`,
  },
};

export const itemFileDataLanguageKey = "SIGN_CONTRACT_DATA_FILEDATA_";

export const fileDataFieldProps = {
  companyName: {
    name: "companyName",
    label: `${itemFileDataLanguageKey}COMPANY_NAME`,
    placeholder: `${itemFileDataLanguageKey}COMPANY_NAME_PLACEHOLDER`,
  },
  companyNumber: {
    name: "companyNumber",
    placeholder: `${itemFileDataLanguageKey}COMPANY_NUMBER_PLACEHOLDER`,
  },
  companyAddressMain: {
    name: "companyAddressMain",
    placeholder: `${itemFileDataLanguageKey}COMPANY_ADDRESS_MAIN_PLACEHOLDER`,
  },
  companyAddressExtra: {
    name: "companyAddressExtra",
    placeholder: `${itemFileDataLanguageKey}COMPANY_ADDRESS_EXTRA_PLACEHOLDER`,
  },
  companyAddressPostalCode: {
    name: "companyAddressPostalCode",
    placeholder: `${itemFileDataLanguageKey}COMPANY_ADDRESS_POSTAL_CODE_PLACEHOLDER`,
  },
  companyAddressCity: {
    name: "companyAddressCity",
    placeholder: `${itemFileDataLanguageKey}COMPANY_ADDRESS_CITY_PLACEHOLDER`,
  },
  initiatingContactFullName: {
    name: "initiatingContactFullName",
    label: `${itemFileDataLanguageKey}INITIATING_CONTACT_FULL_NAME`,
    placeholder: `${itemFileDataLanguageKey}INITIATING_CONTACT_FULL_NAME_PLACEHOLDER`,
  },
  initiatingContactEmail: {
    name: "initiatingContactEmail",
    placeholder: `${itemFileDataLanguageKey}INITIATING_CONTACT_EMAIL_PLACEHOLDER`,
  },
  initiatingContactMobilePhone: {
    name: "initiatingContactMobilePhone",
    placeholder: `${itemFileDataLanguageKey}INITIATING_CONTACT_MOBILE_PHONE_PLACEHOLDER`,
  },
  deliveryAddressMain: {
    name: "deliveryAddressMain",
    label: `${itemFileDataLanguageKey}DELIVERY_ADDRESS_MAIN`,
    placeholder: `${itemFileDataLanguageKey}DELIVERY_ADDRESS_MAIN_PLACEHOLDER`,
  },
  deliveryAddressExtra: {
    name: "deliveryAddressExtra",
    placeholder: `${itemFileDataLanguageKey}DELIVERY_ADDRESS_EXTRA_PLACEHOLDER`,
  },
  deliveryAddressPostalCode: {
    name: "deliveryAddressPostalCode",
    placeholder: `${itemFileDataLanguageKey}DELIVERY_ADDRESS_POSTAL_CODE_PLACEHOLDER`,
  },
  deliveryAddressCity: {
    name: "deliveryAddressCity",
    placeholder: `${itemFileDataLanguageKey}DELIVERY_ADDRESS_CITY_PLACEHOLDER`,
  },
  deliveryContactFullName: {
    name: "deliveryContactFullName",
    label: `${itemFileDataLanguageKey}DELIVERY_CONTACT_FULL_NAME`,
    placeholder: `${itemFileDataLanguageKey}DELIVERY_CONTACT_FULL_NAME_PLACEHOLDER`,
  },
  deliveryContactEmail: {
    name: "deliveryContactEmail",
    placeholder: `${itemFileDataLanguageKey}DELIVERY_CONTACT_EMAIL_PLACEHOLDER`,
  },
  deliveryContactMobilePhone: {
    name: "deliveryContactMobilePhone",
    placeholder: `${itemFileDataLanguageKey}DELIVERY_CONTACT_MOBILE_PHONE_PLACEHOLDER`,
  },
  counterpartyCompanyName: {
    name: "counterpartyCompanyName",
    label: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_NAME`,
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_NAME_PLACEHOLDER`,
  },
  counterpartyCompanyNumber: {
    name: "counterpartyCompanyNumber",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_NUMBER_PLACEHOLDER`,
  },
  counterpartyCompanyAddressMain: {
    name: "counterpartyCompanyAddressMain",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_ADDRESS_MAIN_PLACEHOLDER`,
  },
  counterpartyCompanyAddressExtra: {
    name: "counterpartyCompanyAddressExtra",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_ADDRESS_EXTRA_PLACEHOLDER`,
  },
  counterpartyCompanyAddressPostalCode: {
    name: "counterpartyCompanyAddressPostalCode",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_ADDRESS_POSTAL_CODE_PLACEHOLDER`,
  },
  counterpartyCompanyAddressCity: {
    name: "counterpartyCompanyAddressCity",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_COMPANY_ADDRESS_CITY_PLACEHOLDER`,
  },
  counterpartyContactFullName: {
    name: "counterpartyContactFullName",
    label: `${itemFileDataLanguageKey}COUNTERPARTY_CONTACT_FULL_NAME`,
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_CONTACT_FULL_NAME_PLACEHOLDER`,
  },
  counterpartyContactEmail: {
    name: "counterpartyContactEmail",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_CONTACT_EMAIL_PLACEHOLDER`,
  },
  counterpartyContactMobilePhone: {
    name: "counterpartyContactMobilePhone",
    placeholder: `${itemFileDataLanguageKey}COUNTERPARTY_CONTACT_MOBILE_PHONE_PLACEHOLDER`,
  },
};
